import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const CardOnlineIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 20 20" width={20} height={20} fill="none" {...props}>
            <Path
                fill={color}
                d="M15.165 5.2v-.513c0-.54-.41-.981-.912-.981H5.76c-.501 0-.911.441-.911.98V5.2zM4.848 6.09v3.93c0 .539.41.98.91.98h8.495c.501 0 .912-.441.912-.98V6.09zm8.862 3.105c0 .175-.132.318-.295.318h-.911c-.163 0-.296-.143-.296-.318v-.981c0-.175.133-.318.296-.318h.91c.164 0 .296.143.296.318z"
            />
            <Path
                fill={color}
                d="M18.806 15.087h-1.273V5.862c0-.318-.242-.571-.531-.571h-.875c-.096 0-.169.084-.169.182v.376c0 .104.079.182.169.182h.712v8.315H3.149V6.038h.73c.097 0 .17-.085.17-.182v-.377c0-.104-.079-.182-.17-.182h-.892c-.296 0-.531.26-.531.572v9.218H1.2c-.103 0-.193.09-.193.208v.338c0 .37.277.669.621.669h16.748c.344 0 .622-.3.622-.67v-.337c0-.11-.085-.208-.193-.208m-7.343.078c0 .286-.21.513-.476.513H8.996c-.266 0-.477-.227-.477-.513v-.085h2.938v.085z"
            />
        </Svg>
    )
}

export default CardOnlineIcon
